module.exports = __webpack_public_path__ + "img/amar-akbar.366de2b.png";